<span id="languageMenuAction" class="sr-only">{{ triggerLabel() }}</span>
<span id="languageMenuLabel" class="sr-only">{{ language() | vuiLanguageDisplayName: language() }}</span>
<button
    vds-icon-button
    [vdsTooltip]="triggerLabel()"
    placement="bottom"
    aria-labelledby="languageMenuAction languageMenuLabel"
    appearance="ghost"
    mode="dark"
    [vdsMenuTriggerFor]="languageMenu"
>
    <vds-icon name="earth-filled" />
</button>
<ng-template #languageMenu>
    <vds-menu appearance="dark">
        @for (locale of locales(); track locale.id) {
            <button type="button" (triggered)="languageChange.emit(locale)" vdsMenuItemRadio [checked]="language() === locale.id">
                <span>{{ locale.id | vuiLanguageDisplayName: locale.id }}</span>
            </button>
        }
    </vds-menu>
</ng-template>
